"use client";

import { Mail, MapPin, Phone } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactInformation() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const contactItems = [{
    icon: Phone,
    title: "Phone",
    value: "+52 984 123 4567",
    ref: ref1,
    isVisible: isVisible1,
    delay: "delay-100"
  }, {
    icon: Mail,
    title: "Email",
    value: "contact@ecoluxmaya.com",
    ref: ref2,
    isVisible: isVisible2,
    delay: "delay-200"
  }, {
    icon: MapPin,
    title: "Location",
    value: "Playa del Carmen, Riviera Maya, Mexico",
    ref: ref3,
    isVisible: isVisible3,
    delay: "delay-300"
  }];
  return <section id="contact-information" className="relative min-h-screen flex items-center justify-center py-24 px-6 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549040/img/turquoise_water_ripples_texture.png)]">
      <div className="absolute inset-0 bg-background/40 backdrop-blur-sm" />

      <div className="relative z-10 max-w-2xl mx-auto w-full space-y-8">
        {contactItems.map((item, i) => {
        const IconComponent = item.icon;
        return <div key={i} data-index={i} ref={item.ref} className={`
                glass-effect transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]
                hover:shadow-strong hover:scale-[1.02]
                ${item.isVisible ? `opacity-100 translate-y-0 ${item.delay}` : "opacity-0 translate-y-4"}
              `} style={{
          borderRadius: "2rem 4rem 2rem 4rem",
          padding: "2rem 2.5rem"
        }}>
              <div className="flex items-center gap-6">
                <div className="relative">
                  <IconComponent className="size-10 text-secondary animate-pulse" strokeWidth={1.5} />
                </div>
                <div className="flex-1">
                  <h3 className="font-display text-xl font-semibold text-foreground mb-1">
                    {item.title}
                  </h3>
                  <p className="text-muted-foreground">{item.value}</p>
                </div>
              </div>
            </div>;
      })}
      </div>
    </section>;
}